import { Search } from "@mui/icons-material";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React from "react";

export interface IAMEntitySearchProps<TEntity> {
  isLoading: boolean;
  options: TEntity[];
  value: TEntity | TEntity[];
  placeHolderText: string;
  getOptionLabel: (option: TEntity) => string;
  isOptionEqualToValue: (option: TEntity, value: TEntity) => boolean;
  onChange: (value: TEntity | TEntity[]) => void;
  onOpen?: () => void;
  onClose?: () => void;
  open?: boolean;
}

export default function IAMEntitySearch<TEntity>(
  props: IAMEntitySearchProps<TEntity>
) {
  const [open, setOpen] = React.useState(false);
  return (
    <Autocomplete
      id="group-select"
      sx={{ width: 500 }}
      open={props.open ?? open}
      onOpen={() => {
        props.onOpen?.();
        setOpen(true);
      }}
      onClose={() => {
        props.onClose;
        setOpen(false);
      }}
      loading={props.isLoading}
      multiple={Array.isArray(props.value)}
      options={props.options}
      value={props.value}
      getOptionLabel={props.getOptionLabel}
      isOptionEqualToValue={props.isOptionEqualToValue}
      onChange={(e, v) => props.onChange(v as typeof props.value)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={props.placeHolderText}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <React.Fragment>
                <Search />
              </React.Fragment>
            ),
            endAdornment: (
              <React.Fragment>
                {props.isLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
